// mathjs comes with a lot of advanced functionality we don't need
// (trigonometry, probability, combinatorics, etc); we're mostly only
// interested in the core parser, basic arithmetic operations and fractions.
// http://mathjs.org/docs/custom_bundling.html

import mathCore from 'mathjs/core';
import fraction from 'mathjs/lib/type/fraction';
import arithmetic from 'mathjs/lib/function/arithmetic';
import mathEval from 'mathjs/lib/expression/function/eval';

const math = mathCore.create();

math.import(arithmetic);
math.import(fraction);
math.import(mathEval);

export default math;
